import { render, staticRenderFns } from "./TicketPrint.vue?vue&type=template&id=1386e5d5&"
import script from "./TicketPrint.vue?vue&type=script&lang=js&"
export * from "./TicketPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports